module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-MediumItalic-167926149a4e387cd24b8754f35a2682.woff2";